export default __webpack_public_path__ + "static/media/priestofmitra_white_icon.605d1aad.png";